import React from 'react';
import { Outlet } from 'react-router-dom';

interface UsersRootPageInterface {}

const UsersRootPage: React.FC<UsersRootPageInterface> = () => <Outlet />;

export default UsersRootPage;
